import axios from 'axios'
import { GRAPHQL_ENDPOINT, getClient } from './auth'
import { clearAuth, getCsrfToken } from 'utils'

const AUTH_PATH_PREFIX = '/api/auth/'

export const isRequiredAccessToken = (url: URL): boolean => {
  if (url.origin !== graphqlEndpoint.origin) return false
  if (url.pathname === graphqlEndpoint.pathname) return false
  if (url.pathname.startsWith(AUTH_PATH_PREFIX)) return false
  return true
}
export const throwInvaliedToken = async () => {
  await getClient().catch(() => {
    clearAuth().catch(() => {})
    if (window && window.location && window.location) window.location.href = '/login'
    return Promise.reject()
  })
  return Promise.resolve()
}
export const getFetchConfig = (request: any, isAuthorization = true): object => {
  if (!isAuthorization) {
    return request.length === 1 ? {} : request[1]
  }

  const csrfToken = getCsrfToken()

  if (request.length === 1) {
    const headers = new Headers({ Authorization: `Bearer ${localStorage.getItem('accessToken')}` })
    if (csrfToken) {
      headers.append('X-CSRF-Token', csrfToken)
    }
    return {
      headers,
      credentials: 'include' as RequestCredentials,
    }
  }

  request[1].headers.delete('Authorization')
  request[1].headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`)
  if (csrfToken) {
    request[1].headers.delete('X-CSRF-Token')
    request[1].headers.append('X-CSRF-Token', csrfToken)
  }
  request[1].credentials = 'include'
  return request[1]
}

const graphqlEndpoint = new URL(GRAPHQL_ENDPOINT)
const { fetch: originalFetch } = window

window.fetch = async (...request: any) => {
  let config = getFetchConfig(request, false)
  if (isRequiredAccessToken(new URL(request[0]))) {
    await throwInvaliedToken()
    config = getFetchConfig(request)
  }
  const response = await originalFetch(request[0], config)
  return response
}

axios.interceptors.request.use(async (request: any) => {
  if (isRequiredAccessToken(new URL(request.url))) {
    await throwInvaliedToken()
    request.headers['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`
    const csrfToken = getCsrfToken()
    if (csrfToken) {
      request.headers['X-CSRF-Token'] = csrfToken
    }
    request.withCredentials = true
  }
  return request
})
